import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Every OpenAI call runs in a Cloud Function, so the API key never ships in the browser bundle.

export async function askMeetingSummaryQuestion({
  summaryText = '',
  transcription = '',
  question,
  messages = [],
}) {
  if (!question?.trim()) {
    throw new Error('Please enter a question.');
  }

  const fn = httpsCallable(functions, 'askMeetingSummaryQuestion');
  try {
    const result = await fn({
      summaryText,
      transcription,
      question,
      messages,
    });
    const answer = result.data?.answer;
    if (!answer) {
      throw new Error('No response received from OpenAI.');
    }
    return answer;
  } catch (error) {
    const message =
      error?.message ||
      error?.details ||
      'Failed to get an answer. Please try again.';
    throw new Error(message);
  }
}

export async function generateClientDebrief({ companyName = '', context }) {
  if (!context?.trim()) {
    throw new Error('No client activity available to summarize yet.');
  }

  const fn = httpsCallable(functions, 'generateClientDebrief');
  try {
    const result = await fn({ companyName, context });
    const debrief = result.data?.debrief;
    if (!debrief) {
      throw new Error('No debrief received from OpenAI.');
    }
    return debrief;
  } catch (error) {
    const message =
      error?.message ||
      error?.details ||
      'Failed to generate the debrief. Please try again.';
    throw new Error(message);
  }
}

export async function generateLeadSummary({ companyName = '', intake = '', discovery = '', analysis = '' }) {
  if (!intake.trim() && !discovery.trim() && !analysis.trim()) {
    throw new Error('Add an intake, discovery, or analysis note first.');
  }

  const fn = httpsCallable(functions, 'generateLeadSummary');
  try {
    const result = await fn({ companyName, intake, discovery, analysis });
    const summary = result.data?.summary;
    if (!summary?.overview) {
      throw new Error('No summary received from OpenAI.');
    }
    return summary;
  } catch (error) {
    const message =
      error?.message ||
      error?.details ||
      'Failed to generate the summary. Please try again.';
    throw new Error(message);
  }
}
